import { Component, OnInit } from '@angular/core';
import { ToastrManager } from "ng6-toastr-notifications";
import { Validators, FormGroup, FormBuilder } from "@angular/forms";
import { CoreService } from "../../Services/core.service";
import { TitleService } from 'src/app/shared/Services/title.service';
import { LoaderService } from 'src/app/shared/Services/loader.service';
import { LayoutService } from 'src/app/shared/Services/layout.service';
import { LoggingService } from 'src/app/shared/Services/NGLogger/logging-service.service';
import { Subject, catchError, of, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  private componentDestroyed$: Subject<void> = new Subject(); // For unsubscribing when the component is destroyed
  ForgotForm!: FormGroup;
  ForgoteRes: any;
  CurrentItem: string;
  Submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrManager,
    private coreservice: CoreService,
    private _titleService: TitleService,
    private loaderservice: LoaderService,
    private layoutService: LayoutService,
    private loggingService: LoggingService
  ) {
    var newTitle = 'Forget Password';
    this._titleService.setTitle(newTitle);
    this.forminit();
    this.layoutService.setShowLoginButton(false);
    this.layoutService.setShowRegisterButton(false);

    this.CurrentItem = "Reset Password";
  }
  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    this.layoutService.setShowSidebar(false);
  }

  forgotSubmit() {
    this.Submitted = true;
    if (this.ForgotForm.valid) {

      this.coreservice.VforgetPassword(this.ForgotForm.controls['emailId'].value)
      .pipe(tap((res: any) => {
        this.ForgoteRes = res;
        if (this.ForgoteRes.succeeded) {
          this.toastr.successToastr(this.ForgoteRes.messages[0], "", "top-right");
          this.forminit();
          this.Submitted = false;
        } else {
          this.toastr.errorToastr(this.ForgoteRes.messages[0], "", "top-right");
          this.ForgotForm.controls["emailId"].setValue("");
          this.ForgotForm.controls["emailId"].setErrors({ error: false });
          this.Submitted = false;
        }
      }),
        catchError((error) =>{
          this.loggingService.captureException(error);
          return of(null);
        }),
        takeUntil(this.componentDestroyed$)
        )
        .subscribe();
    } else {
      this.toastr.warningToastr("Invalid Input.", "Error!");
    }
  }

  get fg() {
    return this.ForgotForm.controls;
  }

  forminit() {
    this.ForgotForm = this.formBuilder.group({
      emailId: ["", [Validators.required]]
    });
  }
}
